<template>
  <div
    :ref="generateSafeId(fieldQuestionId, 'wrapper')"
    class="RMPE-DynamicField"
    :class="{ 'RMPE-HasError': fieldHasError }"
  >
    <component
      :is="layout.type"
      :image="layout.image"
      :video="layout.video"
    >
      <div class="field">
        <div class="control is-expanded">
          <label
            class="label RMPE-DynamicField-Label"
            :for="fieldQuestionId"
          >
            <span
              :class="{'RMPE-Required': question.required}"
              v-html="question.formattedLabel"
            />

          </label>

          <HintMessage :hint="question.formattedDescription" />

          <MediaMiddlePartial :layout="layout" />

          <div
            class="select is-fullwidth"
            :class="{'is-multiple': question.multiSelect}"
          >
            <select
              :id="fieldQuestionId"
              ref="auto-focus-target"
              v-model="interfaceValue"
              :multiple="question.multiSelect"
              :class="{ 'is-danger': fieldHasError }"
            >
              <option
                :value="null"
              >
                -
              </option>
              <option
                v-for="option in options"
                :key="option.id"
                :value="option.id"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
        <ErrorMessage
          :field-has-error="fieldHasError"
          :errors="error.errors"
          :is-blurred="isBlurred"
        />
        <div class="RMPE-DynamicForm-SubmitContainer">
          <button
            :disabled="isNextButtonDisabled"
            class="button is-primary RMPE-CustomSubmit"
            @click="goToNextQuestion"
          >
            {{ question.goToNextQuestionButtonLabel }}
          </button>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import DynamicFieldMixin from '../../mixins/dynamic-field-mixin';
import SelectFieldMixin from '../common/select-field';

export default {
  mixins: [DynamicFieldMixin, SelectFieldMixin],
};
</script>

<style scoped lang="scss">
  .control {
    .label {
      //margin-bottom: 0;
    }
  }
</style>
